export function InstagramIcon({ className }: { className?: string }) {
	return (
		<svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className={className}>
			<title>Instagram</title>
			<path d="M7.0301.084c-1.2768.0602-2.1487.264-2.911.5634-.7888.3075-1.4575.72-2.1228 1.3877-.6652.6677-1.075 1.3368-1.3802 2.127-.2954.7638-.4956 1.6365-.552 2.914-.0564 1.2775-.0689 1.6882-.0626 4.947.0062 3.2586.0206 3.6671.0825 4.9473.061 1.2765.264 2.1482.5635 2.9107.308.7889.72 1.4573 1.388 2.1228.6679.6655 1.3365 1.0743 2.1285 1.38.7632.295 1.6361.4961 2.9134.552 1.2773.056 1.6884.069 4.9462.0627 3.2578-.0062 3.668-.0207 4.9478-.0814 1.28-.0607 2.147-.2652 2.9098-.5633.7889-.3086 1.4578-.72 2.1228-1.3881.665-.6682 1.0745-1.3378 1.3795-2.1284.2957-.7632.4966-1.636.552-2.9124.056-1.2809.0692-1.6898.063-4.948-.0063-3.2583-.021-3.6668-.0817-4.9465-.0607-1.2797-.264-2.1487-.5633-2.9117-.3084-.7889-.72-1.4568-1.3876-2.1228C21.2982 1.33 20.628.9208 19.8378.6165 19.074.321 18.2017.1197 16.9244.0645 15.6471.0093 15.236-.005 11.977.0014 8.718.0076 8.31.0215 7.0301.0839m.1402 21.6932c-1.17-.0509-1.8053-.2453-2.2287-.408-.5606-.216-.96-.4771-1.3819-.895-.422-.4178-.6811-.8186-.9-1.378-.1644-.4234-.3624-1.058-.4171-2.228-.0595-1.2645-.072-1.6442-.079-4.848-.007-3.2037.0053-3.583.0607-4.848.05-1.169.2456-1.805.408-2.2282.216-.5613.4762-.96.895-1.3816.4188-.4217.8184-.6814 1.3783-.9003.423-.1651 1.0575-.3614 2.227-.4171 1.2655-.06 1.6447-.072 4.848-.079 3.2033-.007 3.5835.005 4.8495.0608 1.169.0508 1.8053.2445 2.228.408.5608.216.96.4754 1.3816.895.4217.4194.6816.8176.9005 1.3787.1653.4217.3617 1.056.4169 2.2263.0602 1.2655.0739 1.645.0796 4.848.0058 3.203-.0055 3.5834-.061 4.848-.051 1.17-.245 1.8055-.408 2.2294-.216.5604-.4763.96-.8954 1.3814-.419.4215-.8181.6811-1.3783.9-.4224.1649-1.0577.3617-2.2262.4174-1.2656.0595-1.6448.072-4.8493.079-3.2045.007-3.5825-.006-4.848-.0608M16.953 5.5864A1.44 1.44 0 1 0 18.39 4.144a1.44 1.44 0 0 0-1.437 1.4424M5.8385 12.012c.0067 3.4032 2.7706 6.1557 6.173 6.1493 3.4026-.0065 6.157-2.7701 6.1506-6.1733-.0065-3.4032-2.771-6.1565-6.174-6.1498-3.403.0067-6.156 2.771-6.1496 6.1738M8 12.0077a4 4 0 1 1 4.008 3.9921A3.9996 3.9996 0 0 1 8 12.0077"></path>
		</svg>
	);
}

export function XSocialIcon({ className }: { className?: string }) {
	return (
		<svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className={className}>
			<title>X</title>
			<path d="M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932ZM17.61 20.644h2.039L6.486 3.24H4.298Z"></path>
		</svg>
	);
}

export function FacebookIcon({ className }: { className?: string }) {
	return (
		<svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className={className}>
			<title>Facebook</title>
			<path d="M9.101 23.691v-7.98H6.627v-3.667h2.474v-1.58c0-4.085 1.848-5.978 5.858-5.978.401 0 .955.042 1.468.103a8.68 8.68 0 0 1 1.141.195v3.325a8.623 8.623 0 0 0-.653-.036 26.805 26.805 0 0 0-.733-.009c-.707 0-1.259.096-1.675.309a1.686 1.686 0 0 0-.679.622c-.258.42-.374.995-.374 1.752v1.297h3.919l-.386 2.103-.287 1.564h-3.246v8.245C19.396 23.238 24 18.179 24 12.044c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.628 3.874 10.35 9.101 11.647Z"></path>
		</svg>
	);
}

export function QuoteIcon({ width = 46, height = 28 }: { width?: number; height?: number }) {
	return (
		<svg width={width} height={height} viewBox="0 0 46 28" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M10.7273 28C7.54546 28 5 27.0667 3.09091 25.2C1.18182 23.2889 0.227273 20.7111 0.227273 17.4667C0.227273 14.4889 0.954546 11.6 2.40909 8.8C3.90909 5.95556 6 3.46667 8.68182 1.33333L12.6364 5.06667C11.0455 6.48889 9.79546 7.95556 8.88637 9.46667C8.02273 10.9333 7.45455 12.3556 7.18182 13.7333C7.77273 13.5556 8.40909 13.4667 9.09091 13.4667C11.2727 13.4667 13.0455 14.1556 14.4091 15.5333C15.8182 16.8667 16.5227 18.6222 16.5227 20.8C16.5227 22.9778 15.75 24.7556 14.2045 26.1333C12.7045 27.3778 10.8636 28 10.6818 28H10.7273ZM30.1818 28C27 28 24.4545 27.0667 22.5455 25.2C20.6364 23.2889 19.6818 20.7111 19.6818 17.4667C19.6818 14.4889 20.4091 11.6 21.8636 8.8C23.3636 5.95556 25.4545 3.46667 28.1364 1.33333L32.0909 5.06667C30.5 6.48889 29.25 7.95556 28.3409 9.46667C27.4773 10.9333 26.9091 12.3556 26.6364 13.7333C27.2273 13.5556 27.8636 13.4667 28.5455 13.4667C30.7273 13.4667 32.5 14.1556 33.8636 15.5333C35.2727 16.8667 35.9773 18.6222 35.9773 20.8C35.9773 22.9778 35.2045 24.7556 33.6591 26.1333C32.1591 27.3778 30.3182 28 30.1364 28H30.1818Z"
				fill="currentColor"
			/>
		</svg>
	);
}

export function DetailsIcon({ className }: { className?: string }) {
	return (
		<svg
			width="60"
			height="44"
			viewBox="0 0 60 44"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
		>
			<g clipPath="url(#clip0_522_337)">
				<path
					d="M47.4534 18.8118H41.7676C40.8435 18.8118 39.9493 19.1326 39.2391 19.723L35.6068 22.735C34.8966 23.3254 34.0025 23.6462 33.0784 23.6462H28.415C27.1487 23.6462 25.955 24.2537 25.2106 25.2763L24.1196 26.7737"
					stroke="currentColor"
					strokeWidth="2.42579"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M34.9352 30.4787C34.563 30.3546 22.2672 29.7984 19.144 29.6572C18.6734 29.6358 18.2114 29.5118 17.7964 29.2936L6.16371 23.1927C4.78182 22.4697 3.08334 22.8376 2.12501 24.0655C0.905695 25.6356 1.38486 27.9245 3.1304 28.8743L23.8587 40.1176C24.5732 40.507 25.4074 40.6096 26.1946 40.4043C29.9424 39.4374 41.2029 36.5966 44.0394 36.5966H47.4534"
					stroke="currentColor"
					strokeWidth="2.42579"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M58.1235 13.2627H54.8891C53.1393 13.2627 51.7231 14.6788 51.7231 16.4286V39.403C51.7231 41.1528 53.1393 42.569 54.8891 42.569H58.5513"
					stroke="currentColor"
					strokeWidth="2.42579"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M17.4753 2.63988C17.7534 2.63988 18.0187 2.55003 18.2326 2.37462C18.9299 1.80561 20.8423 0.594854 23.6318 1.59597C27.0458 2.82384 30.4599 8.99313 25.1976 13.6907C22.1386 16.4202 20.4059 17.9176 19.4947 18.6877C18.9299 19.1669 18.2155 19.4279 17.4753 19.4279C16.7352 19.4279 16.0207 19.1669 15.456 18.6877C14.5447 17.9134 12.812 16.4202 9.75301 13.6907C4.49072 8.99741 7.90479 2.82812 11.3189 1.59597C14.1083 0.590576 16.0207 1.80133 16.7181 2.37462C16.932 2.55003 17.2015 2.63988 17.4753 2.63988Z"
					stroke="currentColor"
					strokeWidth="2.42579"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_522_337">
					<rect width="59.5324" height="43.784" fill="white" transform="translate(0.233887)" />
				</clipPath>
			</defs>
		</svg>
	);
}

export function ImagesIcon({ className }: { className?: string }) {
	return (
		<svg
			width="52"
			height="45"
			viewBox="0 0 52 45"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
		>
			<g clipPath="url(#clip0_522_346)">
				<path
					d="M44.7944 33.6145C43.6264 34.7825 43.4938 36.635 44.4864 37.957L44.7944 38.3677"
					stroke="currentColor"
					strokeWidth="2.66965"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M44.7944 20.0396C43.6264 21.2075 43.4938 23.06 44.4864 24.382L44.7944 24.7927"
					stroke="currentColor"
					strokeWidth="2.66965"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M44.7944 5.46753C43.6264 6.6355 43.4938 8.488 44.4864 9.80999L44.7944 10.2207"
					stroke="currentColor"
					strokeWidth="2.66965"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M16.9644 11.2175H30.5394V34.2946L23.754 28.1852L16.9644 34.2946V11.2175Z"
					stroke="currentColor"
					strokeWidth="2.66965"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M50.2236 29.5459H30.7788"
					stroke="currentColor"
					strokeWidth="2.66965"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M16.562 29.5459H8.76268C4.90367 29.5459 1.78052 32.6733 1.78052 36.5281C1.78052 40.3828 4.90794 43.5102 8.76268 43.5102H50.2278"
					stroke="currentColor"
					strokeWidth="2.66965"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M50.2236 15.2905H30.7788"
					stroke="currentColor"
					strokeWidth="2.66965"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M16.562 15.2905H8.76268C4.90367 15.2905 1.78052 18.418 1.78052 22.2727C1.78052 26.1274 4.90794 29.2549 8.76268 29.2549H16.562"
					stroke="currentColor"
					strokeWidth="2.66965"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M50.2237 1.33472H8.75853C4.90379 1.33472 1.77637 4.46214 1.77637 8.31688C1.77637 12.1716 4.90379 15.299 8.75853 15.299H16.284"
					stroke="currentColor"
					strokeWidth="2.66965"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_522_346">
					<rect width="51.117" height="44.845" fill="white" transform="translate(0.441406)" />
				</clipPath>
			</defs>
		</svg>
	);
}

export function BreakdownIcon({ className }: { className?: string }) {
	return (
		<svg
			width="60"
			height="58"
			viewBox="0 0 60 58"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
		>
			<g clipPath="url(#clip0_522_291)">
				<path
					d="M56.1255 21.862C56.0998 21.7593 56.0784 21.6566 56.0485 21.5539C52.1381 6.92648 37.1042 -1.76273 22.4768 2.15191C7.84933 6.06226 -0.839874 21.0919 3.07476 35.7236C6.98511 50.3511 22.019 59.0403 36.6465 55.1256C45.4084 52.7811 52.0355 46.4493 55.103 38.6029"
					stroke="currentColor"
					strokeWidth="2.42579"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M38.6658 21.9347C40.1846 23.1284 41.0873 24.6343 41.0873 26.2686C41.0873 30.1576 35.9577 33.3107 29.6344 33.3107C23.3111 33.3107 18.1814 30.1576 18.1814 26.2686C18.1814 22.3797 23.3111 19.2266 29.6344 19.2266C31.8291 19.2266 33.8784 19.6073 35.6197 20.2619"
					stroke="currentColor"
					strokeWidth="2.42579"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M18.1815 25.7681L18.0531 33.8284C18.0446 34.5428 18.4296 35.1503 18.8959 35.6894C23.5293 41.033 35.6797 41.4223 40.3302 36.0402C40.7965 35.5012 41.2072 34.9108 41.2158 34.2006L41.0874 26.2686"
					stroke="currentColor"
					strokeWidth="2.42579"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M22.8105 32.4978V36.9558"
					stroke="currentColor"
					strokeWidth="2.42579"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M27.5723 38.7141V33.593"
					stroke="currentColor"
					strokeWidth="2.42579"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M32.458 39.2361V33.4048"
					stroke="currentColor"
					strokeWidth="2.42579"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M36.9631 32.4551V37.1526"
					stroke="currentColor"
					strokeWidth="2.42579"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M57.8667 43.9207L56.2024 36.9771L49.2588 38.6413"
					stroke="currentColor"
					strokeWidth="2.42579"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_522_291">
					<rect width="58.1547" height="57.2777" fill="white" transform="translate(0.922607)" />
				</clipPath>
			</defs>
		</svg>
	);
}
